import { IonContent } from "@ionic/react";
import styled from "styled-components";
import { useTranslate } from "../contexts/translate";
import { MouseEvent, useRef, useState } from "react";
import { Background } from "../components/ui/Background";
import { Subheader } from "../components/ui/Subheader";
import { BigButton } from "../components/ui/BigButton";
import { PaperBackground } from "../components/ui/PaperBackground";
import Dice from "../components/Dice";
import { Header } from "../components/ui/Header";

// https://codepen.io/lenasta92579651/pen/yLeVmdW

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: calc(var(--u) * 4);
  padding: calc(var(--u) * 4) calc(var(--u) * 2);
`;

const Cell = styled.div`
  //background: rgba(0, 0, 0, 0.2);
  //border: 1px solid black;
  width: calc(var(--u) * 25);
  aspect-ratio: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: black;
  font-size: calc(var(--u) * 3);
  --size: calc(var(--u) * 20);
  --radius: calc(var(--u) * 2);

  .plus {
    width: var(--size);
    aspect-ratio: 1;
    background: rgba(0, 0, 0, 0.2);
    border: 1px solid black;
    border-radius: var(--radius);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
`;

const Dices: React.FC = () => {
  const { translate } = useTranslate();
  const [grid, setGrid] = useState([true, true, true, false, false, false]);

  const dice1 = useRef<{ roll: () => void }>(null);
  const dice2 = useRef<{ roll: () => void }>(null);
  const dice3 = useRef<{ roll: () => void }>(null);
  const dice4 = useRef<{ roll: () => void }>(null);
  const dice5 = useRef<{ roll: () => void }>(null);
  const dice6 = useRef<{ roll: () => void }>(null);

  const onRoll = () => {
    dice1.current?.roll();
    dice2.current?.roll();
    dice3.current?.roll();
    dice4.current?.roll();
    dice5.current?.roll();
    dice6.current?.roll();
  };

  function onClickCell(e: MouseEvent<HTMLDivElement>, index: number) {
    e.preventDefault();
    e.stopPropagation();
    setGrid([...grid.slice(0, index), !grid[index], ...grid.slice(index + 1)]);
  }

  return (
    <>
      <Header size="small" shouldHide />
      <IonContent>
        <Background background="cards">
          <Subheader>
            <BigButton
              icon="dice"
              label={translate("screens.dices.title")}
              to=""
              mode="title"
            />
          </Subheader>
          <IonContent style={{ "--background": "transparent" }}>
            <PaperBackground>
              <Container>
                <Cell onClick={(e) => onClickCell(e, 0)}>
                  <Dice hide={grid[0] === false} ref={dice1} />
                  <div
                    className="plus"
                    style={{ display: grid[0] === false ? "flex" : "none" }}
                  >
                    +
                  </div>
                </Cell>

                <Cell onClick={(e) => onClickCell(e, 1)}>
                  <Dice hide={grid[1] === false} ref={dice2} />
                  <div
                    className="plus"
                    style={{ display: grid[1] === false ? "flex" : "none" }}
                  >
                    +
                  </div>
                </Cell>

                <Cell onClick={(e) => onClickCell(e, 2)}>
                  <Dice hide={grid[2] === false} ref={dice3} />
                  <div
                    className="plus"
                    style={{ display: grid[2] === false ? "flex" : "none" }}
                  >
                    +
                  </div>
                </Cell>

                <Cell onClick={(e) => onClickCell(e, 3)}>
                  <Dice hide={grid[3] === false} ref={dice4} />
                  <div
                    className="plus"
                    style={{ display: grid[3] === false ? "flex" : "none" }}
                  >
                    +
                  </div>
                </Cell>

                <Cell onClick={(e) => onClickCell(e, 4)}>
                  <Dice hide={grid[4] === false} ref={dice5} />
                  <div
                    className="plus"
                    style={{ display: grid[4] === false ? "flex" : "none" }}
                  >
                    +
                  </div>
                </Cell>

                <Cell onClick={(e) => onClickCell(e, 5)}>
                  <Dice hide={grid[5] === false} ref={dice6} />
                  <div
                    className="plus"
                    style={{ display: grid[5] === false ? "flex" : "none" }}
                  >
                    +
                  </div>
                </Cell>
              </Container>
              <BigButton
                onClick={() => onRoll()}
                icon="dice"
                label={translate("screens.dices.roll")}
                to=""
                mode="title"
              />
            </PaperBackground>
          </IonContent>
        </Background>
      </IonContent>
    </>
  );
};

export default Dices;
